import React, {Component} from 'react';
import {Radio, message, Badge, Spin} from 'antd';
import {app} from '../../app';
import ReviewFailModal from '../../components/ReviewFailModal';
import RIrsyw from './ReInsure/RIrsyw';
import RIzzzzr from './ReInsure/RIzzzzr';
import {insuraAuditTitle} from '../insure/insure_api';

class ReInsure extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      review_visible: false,
      reviewInfo: {},
      sel_tab: '1',
      tabs: []
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.dataCountSource();
  }


  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  /**
   * 数据加载
   * @returns {Promise<void>}
   */
  dataCountSource = async () => {
    await this.setData({tabs: await insuraAuditTitle(), loading: false});

  };

  /**
   * 审核结果
   * @param param
   * @returns {Promise<void>}
   */
  handleCheckReview = async (audit, detail, reviewInfo, other_params) => {
    app.alert('正在审核~', 'loading', '35%', 0);
    const {uri, id, id_key, source} = reviewInfo || this.state.reviewInfo;
    let params = {
      audit,
      indexno: app.getData('indexno'),
      account: app.getData('account'),
    };
    params[id_key] = id; //id
    if (audit === 2) params.detail = detail;
    if (other_params && other_params instanceof Object) params = Object.assign(params, other_params);
    const {flag, msg} = await app.post(uri, params);
    message.destroy();
    if (audit === 2) this.CloseReviewModal();
    if (flag === 1) {
      app.alert('审核成功', 'success');
      if (source) source();
      await this.dataCountSource();
      return true;
    } else {
      app.alert(msg, 'warn');
      return false;
    }
  };

  /**
   * 打开不通过审核对话框
   * @param reviewInfo
   * @param reviewInfo.uri
   * @param reviewInfo.id_key
   * @param reviewInfo.source
   * @param reviewInfo.id
   * @constructor
   */
  OpenReviewModal = (reviewInfo) => {
    this.setData({review_visible: true, reviewInfo});
  };

  /**
   * 关闭不通过审核对话框
   * @constructor
   */
  CloseReviewModal = () => {
    this.setData({review_visible: false, reviewInfo: {}});

  };

  /**
   * 审核结果
   * @param rule
   * @param value
   * @param callback
   */
  handleReviewResult = (rule, value, callback) => {
    if (value && value.trim() === '') {
      callback('请输入审核失败原因！');
    }
    callback();
  };

  /**
   * Tab按钮变换
   * @param e
   */
  handleTabBtnChange = (e) => {
    const {value} = e.target;
    this.setData({sel_tab: value});
  };

  render() {
    let {review_visible, sel_tab, tabs, loading} = this.state,
      zi_props = {
        successReview: this.handleCheckReview,
        failReview: this.OpenReviewModal,
      };
    let content_node = null;
    switch (sel_tab) {
      case '1':   //身份审核
        content_node = (<RIrsyw {...zi_props} />);
        break;
      case '2':   //身份审核
        content_node = (<RIzzzzr {...zi_props} />);
        break;
    }
    return (
      <div className="review-info">
        <div className="page-title">保险审核 <span
          style={{color: 'red', fontSize: 16, marginLeft: 20}}>注：务必仔细审核队员保单信息，确保保单信息真实有效。</span></div>
        {
          loading ? (<div style={{textAlign: 'center', padding: 20}}><Spin size="large" /></div>) : (
            <div className="page-content">
              <div className="review-info-tab">
                <Radio.Group value={sel_tab} buttonStyle="solid" onChange={this.handleTabBtnChange}>
                  {
                    tabs.map((tab, index) =>
                      <Badge count={tab.count || 0} key={index}>
                        <Radio.Button value={tab.type + ''}
                                      className='no-select'>{tab.name}</Radio.Button>
                      </Badge>
                    )
                  }
                </Radio.Group>
              </div>
              <div className="review-info-content">
                {content_node}
              </div>
            </div>
          )
        }
        <ReviewFailModal visible={review_visible} close={this.CloseReviewModal}
                         label='失败原因'
                         submit={(detail) => this.handleCheckReview(2, detail)} />
      </div>
    );
  }
}

export default ReInsure;



// WEBPACK FOOTER //
// ./src/routes/review/ReInsure.jsx